import { createContext } from 'react';

export const RealtimeContext = createContext();
